import {
  Box,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  Icon,
  Menu,
  MenuItem,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { api_request, downloadExcel } from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_PUT,
  ENTITY_STATUS,
} from "../../config/constants";
import {
  DELETE_INVOICE_ERROR,
  DELETE_INVOICE_SUCCESS,
  FETCH_DOC_JOB_ERROR,
  FETCH_DOC_JOB_LOADING,
  FETCH_DOC_JOB_SUCCESS,
  FETCH_INVOICES_ERROR,
  FETCH_INVOICES_SUCCESS,
  FETCH_JOB_ERROR,
  FETCH_JOB_STAT_ERROR,
  FETCH_JOB_STAT_LOADING,
  FETCH_JOB_STAT_SUCCESS,
  FETCH_JOB_SUCCESS,
  SET_BILL_REDUCER,
} from "../../store/types/billTypes";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import { useLocation, useNavigate } from "react-router";
import moment from "moment-timezone";
import {
  getImpFieldHelper,
  mapExpenseTypes,
  nativeMuiIconMap,
} from "../../helper/utils";
import { theme } from "../../config/theme";
import CoreButton from "../../core/inputs/CoreButton";
import CoreModal from "../../core/layouts/CoreModal";
import CoreDatePicker from "../../core/inputs/CoreDatePicker";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import {
  downloadStoredExcel,
  setBillReducer,
} from "../../store/actions/billActions";
import Swal from "sweetalert2";
import {
  EXPENSE_TYPES_ERROR,
  EXPENSE_TYPES_SUCCESS,
} from "../../store/types/commonTypes";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import FilterSection from "./FilterSection";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreTextButton from "../../core/inputs/CoreTextButton";

export default function CheckErrors() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userid = useSelector((state) => state?.auth?.uid);

  const [filters, setFilters] = useState([]);
  const [apiFilterOb, setApiFilter] = useState(null);
  const [iconMap, setIconMap] = useState({});
  const [iconBgMap, setIconBgMap] = useState({});
  const [filter, setFilter] = useState(null);
  const [open, setModal] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("DD-MM-YYYY"));
  const [endDate, setEndDate] = useState(moment().format("DD-MM-YYYY"));
  const [fileType, setFileType] = useState("excel");
  const [onlyMine, setOnlyMine] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const [jobModalOpen, setJobModal] = useState(false);
  const [uid, setUid] = useState(userid || null);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [pendingFilters, setPendingFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const isMounted = useRef(false);

  const jobs = useSelector((state) => state?.bill?.jobs?.rows);
  const jobBillsData = useSelector((state) => state?.bill?.jobBillsData);
  const docFields = useSelector((state) => state?.common?.docFields);

  const deleteInvoiceSuccess = useSelector(
    (state) => state?.bill?.deleteInvoiceSuccess,
  );
  const deleteInvoiceError = useSelector(
    (state) => state?.bill?.deleteInvoiceError,
  );
  const category = useSelector((state) => state?.common?.expenseTypes);
  const downloadInvoiceSuccess = useSelector(
    (state) => state?.bill?.downloadInvoiceSuccess,
  );
  const toolDocs = useSelector((state) => state?.common?.toolDocs);
  const allDocs = useSelector((state) => state?.common?.allDocs);
  const { state } = useLocation();
  const basicDetails = useSelector((state) => state?.profile?.basic);
  const docJobs = useSelector((state) => state?.bill?.docJobs?.rows);
  const docJobsLoading = useSelector(
    (state) => state?.bill?.fetchDocJobLoading,
  );
  const jobStatLoading = useSelector(
    (state) => state?.bill?.fetchJobStatLoading,
  );
  const jobStat = useSelector((state) => state?.bill?.jobStat);

  const { docGroupId, label } = state || {}; // Read values passed on state

  const tool = location.pathname.split("/")[1];

  useEffect(() => {
    getMasterData();
    getJobs();
    if (!docGroupId) {
      // alert("call at mount");
      getBills();
    }
    return () => {
      resetBillEdit();
      // alert("unmounting");
    };
  }, []);

  useEffect(() => {
    if (docGroupId) {
      setFilter({
        name: "docGroupId",
        label: "Specific user: " + label,
        value: docGroupId,
      });
    }
  }, [docGroupId]);

  useEffect(() => {
    if (filter) {
      // alert("call at filter change");
      getBills();
    } else if (!filter && !docGroupId) {
      // alert("call at filter change");
      getBills();
    }
  }, [filter]);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    getBills();
  }, [appliedFilters]);

  const resetBillEdit = () => {
    dispatch(setBillReducer({ newDocHisId: null }));
  };

  const getMasterData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/masterData",
        {},
        {
          name: tool + "-filters",
          level: 2,
          _status: "active",
        },
        null,
        EXPENSE_TYPES_SUCCESS,
        EXPENSE_TYPES_ERROR,
        true,
        false,
      ),
    );
  };

  useEffect(() => {
    if (downloadInvoiceSuccess) {
      dispatch(setBillReducer({ downloadInvoiceSuccess: false }));
      setModal(false);
    }
  }, [downloadInvoiceSuccess]);

  const getJobs = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/Jobs",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({
              _status: "active",
              createdBy: uid,
            }),
          ),
        },
        null,
        FETCH_JOB_SUCCESS,
        FETCH_JOB_ERROR,
        true,
        false,
      ),
    );
  };

  const getBills = () => {
    let filterOb = { _status: ENTITY_STATUS.failed };
    if (filter) {
      if (filter?.value === "daily") {
        let startDate = moment().startOf("day").format("YYYY-MM-DD HH:MM");
        let endDate = moment().endOf("day").format("YYYY-MM-DD HH:MM");
        // console.log('DAILY', startDate, endDate);

        filterOb.createdAt = {
          between: [startDate, endDate],
        };
      } else if (filter?.value === "monthly") {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        let endDate = moment().endOf("month").format("YYYY-MM-DD");
        filterOb.createdAt = {
          between: [startDate, endDate],
        };
      } else if (filter?.value === "edited") {
        filterOb._status = "approved";
      } else if (filter?.name === "docGroupId") {
        filterOb.docGroupId = filter?.value;
      } else if (tool !== "invoice-extraction") {
        filterOb["type"] = filter.value;
      } else {
        filterOb["DocHistories.DocData.name"] = filter?.name;
        filterOb["DocHistories.DocData.value"] = filter?.value;
      }
    }
    const modalFilterOb = {};
    Object.entries(appliedFilters).forEach(([key, val]) => {
      if (!val) return;
      if (key === "dateRange") {
        if (val === "today") {
          modalFilterOb.createdAt = {
            between: [
              moment().startOf("day").format("YYYY-MM-DD HH:MM"),
              moment().endOf("day").format("YYYY-MM-DD HH:MM"),
            ],
          };
        } else if (val === "week") {
          modalFilterOb.createdAt = {
            between: [
              moment().startOf("isoWeek").format("YYYY-MM-DD"),
              moment().endOf("isoWeek").format("YYYY-MM-DD"),
            ],
          };
        } else if (val === "month") {
          modalFilterOb.createdAt = {
            between: [
              moment().startOf("month").format("YYYY-MM-DD"),
              moment().endOf("month").format("YYYY-MM-DD"),
            ],
          };
        }
      } else {
        modalFilterOb[key] = val;
      }
    });
    setApiFilter({
      // tool: location.pathname.split("/")[1],
      ...filterOb,
      ...modalFilterOb,
    });
  };

  useEffect(() => {
    if (deleteInvoiceSuccess) {
      getBills();
      dispatch({
        type: SET_BILL_REDUCER,
        payload: {
          deleteInvoiceSuccess: false,
          deleteInvoiceError: false,
          deleteInvoiceMsg: null,
        },
      });
    }
  }, [deleteInvoiceSuccess, deleteInvoiceError]);

  const onViewInvoice = (doc) => {
    dispatch(setBillReducer({ docId: doc.id, docType: doc.type }));
    navigate("/" + doc.tool + "/single");
  };

  const getOtherCols = () => {
    let firstData =
      jobBillsData && jobBillsData[0] && jobBillsData[0]?.DocHistories
        ? jobBillsData[0]?.DocHistories[0]?.DocData
        : [];
    let cols = [];
    for (let i = 0; i < firstData?.length; i++) {
      cols.push({
        view: (row) => {
          return row?.DocHistories &&
            row?.DocHistories[0]?.DocData &&
            row?.DocHistories[0]?.DocData[i]
            ? row?.DocHistories[0]?.DocData[i].value
            : "";
        },
        name: firstData[i]?.name,
        label: firstData[i]?.label || firstData[i]?.name,
      });
    }
    return cols;
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleApplyModalFilters = () => {
    setAppliedFilters({ ...pendingFilters });
    setFilterModalOpen(false);
  };

  const handleClearModalFilters = () => {
    setPendingFilters({});
    setAppliedFilters({});
    setFilterModalOpen(false);
  };

  const getJobStat = (jobId) => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/job/" + jobId + "/stat",
        {},
        {},
        FETCH_JOB_STAT_LOADING,
        FETCH_JOB_STAT_SUCCESS,
        FETCH_JOB_STAT_ERROR,
        true,
        false,
      ),
    );
  };

  const handleJobModal = () => {
    if (!jobModalOpen) {
      dispatch(
        api_request(
          API_METHOD_GET,
          "/business/all/Jobs",
          {},
          {
            _defaultFilter: encodeURIComponent(
              JSON.stringify({
                type: "bulk-doc-processing",
                toolType: tool,
                createdBy: uid,
              }),
            ),
            _order: encodeURIComponent(JSON.stringify({ createdAt: "DESC" })),
          },
          FETCH_DOC_JOB_LOADING,
          FETCH_DOC_JOB_SUCCESS,
          FETCH_DOC_JOB_ERROR,
          true,
          false,
        ),
      );
      setJobModal(true);
    }
  };

  console.log("JOB", jobStat);

  const filtersConfig = [
    {
      key: "createdBy",
      label: "User",
      options: [{ label: "Only Mine", value: uid }],
    },
    {
      key: "jobId",
      label: "Job",
      options: (jobs || []).map((job) => ({
        label:
          job?.extraInfo?.uniqueId ||
          job?.createdBy + "-" + new Date(job?.createdAt).getTime(),
        value: job.id,
      })),
    },
    {
      key: "type",
      label: "Tool",
      options: (allDocs || []).map((doc) => ({
        label: doc.label || doc.name,
        value: doc.name,
      })),
    },
  ];

  return (
    <Box style={{ width: "100%" }}>
      <CoreModal
        title="Job Status"
        open={jobModalOpen}
        handleClose={() => {
          setJobModal(false);
        }}
      >
        {docJobsLoading ? (
          <Skeleton variant="rounded" height={150} />
        ) : (
          <Box>
            <Box style={{ height: 30 }}>
              <Grid container>
                <Grid style={{ textAlign: "center" }} item xs={5}>
                  <strong>ID</strong>
                </Grid>
                <Grid style={{ textAlign: "center" }} item xs={3}>
                  <strong>Status</strong>
                </Grid>
                <Grid style={{ textAlign: "center" }} item xs={4}>
                  <strong>Stat</strong>
                </Grid>
              </Grid>
            </Box>
            <Box style={{ minHeight: 350, maxHeight: 350, overflowY: "auto" }}>
              {docJobs?.slice(0, 10)?.map((docJob) => (
                <Box style={{ height: 30 }}>
                  <Grid container>
                    <Grid item xs={5}>
                      {docJob?.extraInfo?.uniqueId
                        ? docJob?.extraInfo?.uniqueId
                        : docJob.createdBy +
                          "-" +
                          new Date(docJob?.createdAt).getTime()}
                    </Grid>
                    <Grid item xs={3}>
                      {docJob._status}
                    </Grid>
                    <Grid item xs={4}>
                      <p
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {jobStat && Number(jobStat.jobId) === docJob.id ? (
                          <CoreTextButton
                            color="primary"
                            disabled={jobStatLoading}
                            onClick={() => getJobStat(docJob.id)}
                          >
                            {jobStat?.stat}
                          </CoreTextButton>
                        ) : (
                          <CoreIconButton
                            color="primary"
                            disabled={jobStatLoading}
                            onClick={() => getJobStat(docJob.id)}
                          >
                            <Icon>data_usage</Icon>
                          </CoreIconButton>
                        )}
                      </p>
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Box>
            <CoreButtonContainer>
              <CoreButton
                color="error"
                onClick={() => {
                  setJobModal(false);
                }}
              >
                Cancel
              </CoreButton>
            </CoreButtonContainer>
          </Box>
        )}
      </CoreModal>
      <CoreModal
        title="Filters"
        open={filterModalOpen}
        handleClose={() => setFilterModalOpen(false)}
      >
        <Box style={{ minWidth: 340, padding: "8px 0" }}>
          {filtersConfig.map((fc) => (
            <Box key={fc.key} style={{ marginBottom: 16 }}>
              <CoreAutoComplete
                label={fc.label}
                options={fc.options}
                value={
                  fc.options.find((o) => o.value === pendingFilters[fc.key]) ||
                  null
                }
                onChange={(_, val) =>
                  setPendingFilters((prev) => ({
                    ...prev,
                    [fc.key]: val?.value || null,
                  }))
                }
                getOptionLabel={(o) => o?.label || ""}
                isOptionEqualToValue={(o, v) => o?.value === v?.value}
                size="small"
              />
            </Box>
          ))}
          <CoreButtonContainer>
            <CoreButton color="error" onClick={handleClearModalFilters}>
              Clear
            </CoreButton>
            <CoreContainedButton
              color="primary"
              onClick={handleApplyModalFilters}
            >
              Apply
            </CoreContainedButton>
          </CoreButtonContainer>
        </Box>
      </CoreModal>
      <Box>
        <Grid container style={{ padding: 8 }}>
          <Grid item xs={10}>
            <CoreTypographyBody1 variant="h6" component="div">
              All Documents
              {filter?.value && (
                <Chip
                  onDelete={() => {
                    if (filter.name === "docGroupId") {
                      navigate("/" + tool + "/docs/view");
                      setFilter(null);
                    } else {
                      setFilter(null);
                    }
                  }}
                  color="secondary"
                  style={{
                    marginLeft: 16,
                    color: theme.palette.text.primary,
                  }}
                  label={filter.label}
                />
              )}
            </CoreTypographyBody1>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <CoreIconButton
              onClick={() => {
                setPendingFilters({ ...appliedFilters });
                setFilterModalOpen(true);
              }}
            >
              <Icon
                sx={{
                  color: Object.values(appliedFilters).some(Boolean)
                    ? theme.palette.primary.main
                    : "inherit",
                }}
              >
                filter_alt
              </Icon>
            </CoreIconButton>
          </Grid>
        </Grid>

        <CoreDataTable
          id="documentList"
          actions={[]}
          rowActions={[{ icon: "visibility", onClick: onViewInvoice }]}
          columns={[
            {
              view: (row) => {
                return row._status === ENTITY_STATUS.processing ? (
                  <Icon title="processing" sx={{ fontSize: 16 }}>
                    autorenew
                  </Icon>
                ) : row._status === ENTITY_STATUS.failed ? (
                  <Icon
                    title="failed"
                    sx={{ fontSize: 16, color: theme.palette.error.main }}
                  >
                    cancel
                  </Icon>
                ) : row._status === ENTITY_STATUS.approved ? (
                  <Icon
                    title="approved"
                    sx={{ fontSize: 16, color: theme.palette.success.main }}
                  >
                    check_circle
                  </Icon>
                ) : row._status === ENTITY_STATUS.rejected ? (
                  <Icon
                    title="rejected"
                    sx={{ fontSize: 16, color: theme.palette.error.main }}
                  >
                    cancel
                  </Icon>
                ) : row._status === ENTITY_STATUS.viewed ? (
                  <Icon
                    title="viewed"
                    sx={{ fontSize: 16, color: theme.palette.success.main }}
                  >
                    bookmark
                  </Icon>
                ) : (
                  ""
                );
              },
              name: "",
              label: "",
              width: "1%",
            },
            {
              view: (row) => {
                return row?.User?.Person?.firstName;
              },
              name: "uploadedby",
              label: "Uploaded By",
              // width: "20%",
            },
            {
              view: (row) => {
                return moment(row?.createdAt).format("DD-MM-YYYY");
              },
              name: "date",
              label: "Date",
              width: "10%",
            },
            {
              view: (row) => {
                return row.originalFileName;
              },
              name: "File name",
              label: "File name",
              width: "30%",
            },
            {
              view: (row) => {
                return row?.info?.error;
              },
              name: "Error",
              label: "Error Details",
              width: "30%",
            },
          ]}
          rows={jobBillsData || []}
          searchable={true}
          apiDetails={{
            method: API_METHOD_GET,
            path: "/business/all/DocList",
            successType: FETCH_INVOICES_SUCCESS,
            errorType: FETCH_INVOICES_ERROR,
            authorized: true,
            searchKey: "DocHistories.DocData.value",
          }}
          userFilter={apiFilterOb}
        />
      </Box>
    </Box>
  );
}
